var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lib-tabs" },
    _vm._l(_vm.tabs, function (tab, index) {
      return _c(
        "div",
        {
          staticClass: "lib-tab",
          class: {
            _selected: index === _vm.value,
            _shrinkable: tab.shrinkable,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("input", index)
            },
          },
        },
        [
          tab.suffix && tab.shrinkable
            ? [
                _c("span", { staticClass: "lib-tab-shrink" }, [
                  _vm._v(_vm._s(tab.shrinkable) + " "),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(tab.suffix))]),
              ]
            : [_vm._v("\n            " + _vm._s(tab) + "\n        ")],
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }